/** @jsx jsx */
import { Alert, Button, Intent, Menu, MenuItem, Popover, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { css, jsx } from '@emotion/core';
import { Fragment, useState } from 'react';
import AppToaster from '../../../AppToaster';
import {
  LocationInfoFragment,
  useDeleteLocationMutation,
  useForceDeleteLocationMutation,
  useRestoreLocationMutation,
} from '../../../generated/graphql';

type LocationDetailMenuProps = {
  location: LocationInfoFragment;
  onEdit: () => void;
};

const LocationDetailMenu = ({ location, onEdit }: LocationDetailMenuProps) => {
  const { id } = location;
  const options = {
    variables: {
      id,
    },
  };
  const [isForceDeleteAlertOpen, setIsForceDeleteAlertOpen] = useState(false);

  const [deleteLocation, { loading: deleting }] = useDeleteLocationMutation({
    ...options,
    onCompleted: () => AppToaster.success(`${location.name}  wurde in den Papierkorb gelegt`),
  });
  const [restoreLocation, { loading: restoring }] = useRestoreLocationMutation({
    ...options,
    onCompleted: () => AppToaster.success(`${location.name}  wurde wiederhergestellt`),
  });
  const [forceDeleteLocation, { loading: forceDeleting }] = useForceDeleteLocationMutation({
    ...options,
    onCompleted: () => AppToaster.success(`${location.name}  wurde endgültig entfernt`),
  });

  if (!!location.deleted_at) {
    return (
      <Fragment>
        <Alert
          isOpen={isForceDeleteAlertOpen}
          cancelButtonText="Abbrechen"
          confirmButtonText="Entfernen"
          icon={IconNames.DELETE}
          intent={Intent.DANGER}
          onClose={() => setIsForceDeleteAlertOpen(false)}
          onConfirm={forceDeleteLocation as any}
        >
          <p>Soll diese Lokation wirklich undwiderruflich entfernt werden?</p>
        </Alert>
        <Button
          text="Wiederherstellen"
          icon={IconNames.OFFLINE}
          css={styles.headerButton}
          onClick={restoreLocation as any}
          loading={restoring}
        />
        <Popover
          position={Position.BOTTOM}
          content={
            <Menu>
              <MenuItem text="Bearbeiten" icon={IconNames.EDIT} onClick={onEdit} />
              <MenuItem
                text="Entfernen"
                icon={IconNames.DELETE}
                intent={Intent.DANGER}
                onClick={() => setIsForceDeleteAlertOpen(true)}
              />
            </Menu>
          }
        >
          <Button icon={IconNames.MORE} css={styles.headerButton} loading={forceDeleting} />
        </Popover>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Button text="Bearbeiten" icon={IconNames.EDIT} css={styles.headerButton} onClick={onEdit} />
      <Popover
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem text="In den Papierkorb" icon={IconNames.TRASH} onClick={deleteLocation as any} />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} css={styles.headerButton} loading={deleting} />
      </Popover>
    </Fragment>
  );
};

export default LocationDetailMenu;

const styles = {
  statusTag: css`
    margin-left: 10px;
  `,
  headerButton: css`
    margin-left: 10px;
  `,
};
